<template>
  <div>
    <div
      id="equipment-number-form"
      class="p-4 my-4"
    >
      <p
        v-if="!disabled"
        class="mb-4"
      >
        {{ $t('appointmentPage.equipment.equipmentNumberInstruction') }}
      </p>

      <div class="grid">
        <div class="col col-12 md:col-6">
          <div class="grid field mb-0">
            <label
              for="equipment-number"
              class="col-12 mb-2 md:col-5 md:mb-0 required-input font-bold"
            >{{
              $t('appointmentPage.equipment.equipmentNumber')
            }}</label>
            <div class="col-12 md:col-6">
              <InputNumber
                id="equipment-number"
                v-model="v$.nbEquipments.$model"
                class="w-full"
                :class="{'invalid-input': v$.nbEquipments.$error }"
                type="number"
                :min="0"
                show-buttons
                :disabled="disabled"
              />
              <div
                v-for="error of v$.nbEquipments.$errors"
                :key="error.$uid"
                class="input-errors"
              >
                <div class="error-msg">
                  {{ error.$message }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col col-12 md:col-6 hidden md:flex">
          <span
            class="flex align-items-center"
            v-if="nbEquipments > 0 && !checkIsSpecialRequestValue"
          >
            <i class="pi pi-clock mr-2" /> {{ $t('appointmentPage.control.estimatedDuration') }} &nbsp;
            <strong>{{ controlDurationString }}</strong>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {convertMinsToHrsMinsString} from "@/shared/utils/dateTimeUtils";
import {useVuelidate} from "@vuelidate/core";
import InputNumber from 'primevue/inputnumber';
import {minValue, required} from "@/i18n/i18nValidators";

export default {
  name: 'EquipmentNumberForm',
  components: {InputNumber},
  props: {
    modelValue: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isSpecialRequest: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'durationChanged'],
  setup() {
    return {
      v$: useVuelidate()
    }
  },
  validations() {
    return {
      nbEquipments: {required, minValue: minValue(0)},
    }
  },
  data() {
    return {
      nbEquipments: this.modelValue,
      intervals: this.$store.getters['setting/getIntervals']
    }
  },
  computed: {
    duration() {
      // --- Trouve le premier élément qui possède la même valeur ou supérieur au nombre d'équipement saisi --- //
      let interval = this.intervals.find(({ limitMaxEquipment }) => limitMaxEquipment >= this.modelValue);
      // --- Si aucun élément de la liste ne correspond avec le nombre d'équipement saisi, la valeur prise sera celle du nombre d'équipement illimité --- //
      if(interval == undefined) {
        interval = this.intervals.find(({ limitMaxEquipment }) => limitMaxEquipment == -1);
      }
      const result = interval.time;
      this.$emit('durationChanged', result)
      return result
    },
    controlDurationString() {
      return convertMinsToHrsMinsString(this.duration)
    },
    checkIsSpecialRequestValue(){
      // --- force vue to detect changement and refresh vue --- //
      this.controlDurationString;
      return this.isSpecialRequest;
    }
  },
  mounted() {
    this.$watch('nbEquipments', () => {
      if (this.v$.nbEquipments.$invalid) {
        this.$emit('update:modelValue', 0)
      } else {
        this.$emit('update:modelValue', this.nbEquipments)
      }
    })
  },
}
</script>

<style lang="scss" scoped>
#equipment-number-form {
  background-color: $light-grey;
}
</style>
